<template>
  <span>{{ formattedAmount }}</span>
</template>

<script lang="ts">
import CF from 'currency-formatter';
import { defineComponent } from 'vue';
import { IPriceFormattedAmount } from '../interfaces';

const DASH = '\u2013'
const NBSP = '\u00a0'

export default defineComponent({
  props: {
    amount: { type: Number, default: undefined },
    cents: { type: Boolean, default: false },
    dash: { type: Boolean, default: true },
    prefix: { type: Boolean, default: false },
    symbol: { type: Boolean, default: true },
  },

  computed: {
    formattedAmount() {
      const zero = this.dash ? DASH : '%v'
      const space = this.symbol ? NBSP : ''

      const config: IPriceFormattedAmount = {
        locale: 'de-DE',
        precision: this.cents ? 2 : 0,
        format: {
          pos: `%v${space}%s`,
          neg: `-%v${space}%s`,
          zero: `${zero}${space}%s`,
        },
      }

      if (!this.symbol) {
        config.symbol = ''
      }
      if (this.prefix) {
        config.format.pos = '+' + config.format.pos
        config.format.neg = '-' + config.format.neg
        config.format.zero = '+' + config.format.zero
      }

      return CF.format(this.amount ?? 0, config as CF.FormatOptions)
    },
  },
})
</script>
